import React from 'react'
import { SwipeableDrawer, SwipeableDrawerProps } from '@material-ui/core'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'
import { isIOS } from '../../common/helpers/isNative'

const YumDrawer = withStyles((theme: Theme) =>
  createStyles({
    paper: {
      backgroundColor: '#F2F2F6',
      padding: '16px', // '16px 16px 0 16px',
      borderTopLeftRadius: '16px',
      borderTopRightRadius: '16px',
      maxWidth: '500px',

      /* iOS Safari 11.2, Safari 11 */
      '@supports (bottom: constant(safe-area-inset-bottom))': {
        paddingBottom: 'calc(constant(safe-area-inset-bottom) + 16px)',
      },

      /* iOS Safari 11.4+, Safari 11.1+, Chrome 69+, Opera 56+ */
      '@supports (bottom: env(safe-area-inset-bottom))': {
        paddingBottom: 'calc(env(safe-area-inset-bottom) + 16px)',
      },
    },
  }),
)(({ classes, ...props }: SwipeableDrawerProps) => {
  return (
    <SwipeableDrawer
      id="yum-drawer"
      classes={classes}
      anchor="bottom"
      disableBackdropTransition={!isIOS}
      disableDiscovery={isIOS}
      {...props}
    />
  )
})

export default YumDrawer
